import { resellersModalRequest } from "../components/resellersModalRequest";
import { emailValidation } from "../components/emailValidation";

export const formSubmitEnable = {
	init: function(deliveryFormContainer) {
		if (!deliveryFormContainer) return;
		this.requiredInputs = deliveryFormContainer.querySelectorAll('.jsFieldRequired input');
		this.submitButton = deliveryFormContainer.querySelector('[data-form="submit"]');
		this.codeFieldWrapper = deliveryFormContainer.querySelector('.jsRestrictedCode');

		this.codeInput = this.codeFieldWrapper.querySelector('input');
		this.codePostalError = deliveryFormContainer.querySelector('.checkout-form-fields__postal-code-error');
		this.codeInputError = deliveryFormContainer.querySelector('.zip-code-error');
		this.codePostalText = this.codePostalError.querySelector('p');
		this.restrictedPostalCodes = ['20', '97', '98'];
		this.digitsRegex = /^\d+$/;
		this.codeCheck = false;
		this.countryCookie = resellersModalRequest.getCountryCookie('country');

		this.assignEventListener();
		this.changeSubmitState();
		if (!this.codeCheck && this.codeInput.value.length > 0) this.showErrorMessage();
	},

	assignEventListener: function() {
		[].slice.call(this.requiredInputs).forEach(input => {
			input.addEventListener('input', (e)=> {
				if (e.currentTarget === this.codeInput) {
					let inputVal = e.currentTarget.value;
					e.currentTarget.value = inputVal.replace(/[^0-9]+/g, '');
				}
				this.changeSubmitState(e.currentTarget);
			});
		});

		this.codeInput.addEventListener('blur', ()=> {
			if (!this.codeCheck) this.showErrorMessage();
		});
	},

	checkInputsValue: function() {
		return [].slice.call(this.requiredInputs).filter(input => {
			return (input.value).trim().length === 0;
		}).length === 0;
	},

	changeSubmitState: function() {
		this.codeCheck = this.checkPostalCode();
		if (this.checkInputsValue() && this.codeCheck && emailValidation.checkEmail()) {
			this.submitButton.removeAttribute('disabled');
		} else {
			this.submitButton.setAttribute('disabled', true);
		}
	},

	checkPostalCode: function() {
		const inputVal = this.codeInput.value,
			  checkIfOnlyDigit = this.digitsRegex.test(inputVal);
		if (!checkIfOnlyDigit) return;
		if (this.countryCookie === 'FR' && inputVal.length === 5) {
			if (this.restrictedPostalCodes.indexOf(inputVal.substring(0, 2)) > -1) {
				this.showErrorMessage();
				this.codePostalError.style.height = this.codePostalText.offsetHeight + 'px';
				return false;
			} else {
				this.hideErrors();
				return true;
			}
		} else if (this.countryCookie === 'BE' && inputVal.length === 4) {
			this.hideErrors();
			return true;
		} else if (this.countryCookie !== 'BE' && this.countryCookie !== 'FR' && inputVal.length <= 5) {
			this.hideErrors();
			return true;
		}
	},

	showErrorMessage: function() {
		this.codeFieldWrapper.classList.add('Error');
		this.codeInputError.classList.add('zip-code-error--visible');
	},

	hideErrors: function() {
		this.codeFieldWrapper.classList.remove('Error');
		this.codeInputError.classList.remove('zip-code-error--visible');
		this.codePostalError.style.height = 0;
	}
}
